import React, {Component} from "react"
import PropTypes from "prop-types"

import {withRouter} from "react-router-dom"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import Sidebar from "components/Sidebar/Sidebar"
import NavigationSidebar from "components/Navigation/NavigationSidebar"
import CartMini from "components/Cart/CartMini"
import app from "app.controller"
import {Button, Icon} from "semantic-ui-react"

const toCheckout = (history) => {
  history.push( "/checkout" )
}

@withRouter
class FullWidthLayout extends Component {
  render() {
    return (
      <div>
        <Sidebar
          right
          open={app.sidebar.open}
          toggle={app.sidebar.toggle}
          close={app.sidebar.close}>
          <section>
            <Button
              style={{ width: "100%" }}
              onClick={app.sidebar.toggle.dispatch}
              color="primary"> <Icon name="triangle-left"/>Weiter Einkaufen</Button> <br/></section>
          <CartMini/>
          <section>
            <Button
              style={{ width: "100%" }}
              onClick={() => {
                app.sidebar.close.dispatch()
                toCheckout(this.props.history)
              }}>{translate("shop.order")}<Icon name="chevron right"/> </Button>
          </section>
        </Sidebar>
        <Sidebar
          left
          open={app.sidebarLeft.open}
          toggle={app.sidebarLeft.toggle}
          close={app.sidebarLeft.close}
        >
          <SidebarLeft/>
        </Sidebar>

        <div id="page-wrap"
             className="wrapper-wide ">
          <Header/>
          <div id="page-container">
            {this.props.children}
          </div>
          <Footer/>
        </div>
      </div>
    )
  }
}

FullWidthLayout.propTypes = {
  children: PropTypes.any
}

const SidebarLeft = () => {
  return (
    <div>
      <section>
        <Button
          style={{ width: "100%" }}
          onClick={app.sidebarLeft.toggle.dispatch}
          type="primary"> <Icon icon="angle right"/>Weiter Einkaufen</Button> <br/></section>
      <section>
        <NavigationSidebar/>
      </section>
    </div>
  )
}

export default FullWidthLayout



// WEBPACK FOOTER //
// ./src/theme/base/layout/FullWidthLayout.js